import React from "react";
import MailchimpSubscribe from "react-mailchimp-subscribe";
import threeDots from "../assets/three-dots.svg";

function CustomForm({ status, message, onValidated, className = "" }) {
  let email, name;
  const submit = () =>
    email &&
    name &&
    email.value.indexOf("@") > -1 &&
    onValidated({
      EMAIL: email.value,
      FNAME:
        name.value.indexOf(" ") !== -1
          ? name.value.substring(0, name.value.lastIndexOf(" "))
          : name.value,
      LNAME:
        name.value.indexOf(" ") !== -1
          ? name.value.substring(name.value.lastIndexOf(" ") + 1)
          : undefined,
    });

  return (
    <div
      className={`flex flex-col md:flex-row space-y-6 md:space-y-0 md:space-x-6`}
    >
      <input
        className="h-16 flex-grow w-full border-2 border-primary p-4 text-xl"
        ref={(node) => (name = node)}
        type="text"
        placeholder="Name"
      />

      <input
        className="h-16 flex-grow w-full border-2 border-primary p-4 text-xl"
        ref={(node) => (email = node)}
        type="email"
        placeholder="Email"
      />

      {status !== "sending" && (
        <button
          className="h-16 px-4 bg-primary flex flex-col justify-center"
          onClick={submit}
        >
          <p className="text-white text-center text-xl w-full">Submit</p>
        </button>
      )}

      {status === "sending" && (
        <div className="h-16 px-6 bg-primary flex flex-col justify-center">
          <img src={threeDots} alt="loading..." />
        </div>
      )}
    </div>
  );
}

export default function EmailRegister({ className }) {
  var url =
    "https://lostwithlydia.us1.list-manage.com/subscribe/post?u=742a99409be97f3e956ae8d6d&amp;id=f50e6d5999";

  return (
    <MailchimpSubscribe
      url={url}
      render={({ subscribe, status, message }) => (
        <div className={className}>
          {status === "error" && (
            <div
              className="text-white text-sm bg-red-400 p-2 mb-6"
              dangerouslySetInnerHTML={{ __html: message }}
            />
          )}

          {status !== "success" && (
            <CustomForm onValidated={(formData) => subscribe(formData)} />
          )}

          {status === "success" && (
            <p className="text-2xl text-center">Thanks for Subscribing!</p>
          )}
        </div>
      )}
    />
  );
}
